import React, {useState, useEffect, useRef} from 'react';

import TooltipPortal from './toolTipPortal';

import './toolTipComponent.css';

const ToolTipComponent = ({
  toolTipArrowStyle = {},
  toolTipContainerStyle = {},
  toolTipLabelStyle = {},
  toolTipPosition = 'right',
  toolTipTxt = '',
}) => {
  const targetRef = useRef(null);
  const [showPortal, setShowPortal] = useState(null);

  useEffect(() => {
    if (targetRef.current) {
      setShowPortal(true);
    }
  }, [targetRef]);

  return (
    <div
      ref={targetRef}
      style={{
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
      }}>
      {showPortal && (
        <TooltipPortal
          targetRef={targetRef}
          toolTipArrowStyle={toolTipArrowStyle}
          toolTipContainerStyle={toolTipContainerStyle}
          toolTipLabelStyle={toolTipLabelStyle}
          toolTipTxt={toolTipTxt}
          toolTipPosition={toolTipPosition}
        />
      )}
    </div>
  );
};

export default ToolTipComponent;
